import * as React from "react";

import { FilterOptionControl } from "../common";

import { PresentationFacet } from "../model";

import {
  usePlpPresenterForTheFilterMenu_Mobile,
  useProductListController_forFiltering,
  useProductListState,
} from "../providers";

interface SubMenuProps {
  whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile:
    | PresentationFacet
    | undefined;
}

export const SubMenu: React.FunctionComponent<SubMenuProps> = (props) => {
  const { whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile } = props;

  const { selectedOptions } = useProductListState();
  const { isOptionSelected } = useProductListController_forFiltering();

  const { handleActionFilterOption_onMobile } =
    usePlpPresenterForTheFilterMenu_Mobile();

  const options = React.useMemo(() => {
    if (!whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile) {
      return null;
    }

    const filterOptions =
      whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile.potentialOptions;
    return filterOptions.map((option) => {
      const isSelected = isOptionSelected(
        whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile,
        option
      );

      const action: React.MouseEventHandler = () => {
        handleActionFilterOption_onMobile(option);
      };

      return (
        <div
          key={`plp-mobile-submenu-${whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile.key}-${option.id}`}
          className={`option ${isSelected ? "selected" : ""}`}
          onClick={action}
        >
          <div className="left">
            <FilterOptionControl
              facet={whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile}
              option={option}
              idPrefix="mobile"
            />
          </div>
          <div className="count">{option.count}</div>
        </div>
      );
    });
  }, [
    whatIsTheExclusivelyOpenFilterSubMenuRightNow_onMobile,
    selectedOptions,
    handleActionFilterOption_onMobile,
  ]);

  return <React.Fragment>{options}</React.Fragment>;
};
